import * as React from "react";
import styled from "@mui/material/styles/styled";
import LampIconSmall from "../../../assets/icons-lamp.png";
import LampIconMedium from "../../../assets/icons-lamp@2x.png";
import LampIconLarge from "../../../assets/icons-lamp@3x.png";

//region [[ Styles ]]

const RefineIconImage = styled("img")(
  ({ size }: { size: "small" | "medium" | "large" }) => ({
    marginLeft: "1px",
    width: size === "small" ? "14px" : size === "medium" ? "20px" : "28px",
    height: size === "small" ? "14px" : size === "medium" ? "20px" : "28px",
    padding: size === "large" ? "2px" : "0px",
  }),
);

const RefineIconContainer = styled("div")(
  ({
    size,
    lightoff,
  }: {
    size: "small" | "medium" | "large";
    lightoff: number;
  }) => ({
    width: "max-content",
    height: "max-content",
    display: "flex",
    borderRadius: "50%",
    marginRight: "5px",
    opacity: lightoff === 1 ? 0 : 1,
    backgroundColor: lightoff === 1 ? "transparent" : "#f7d172",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RefineIconProps {
  className?: string;
  size: "small" | "medium" | "large";
  lightOff?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RefineIcon = ({ ...props }: RefineIconProps) => {
  return (
    <RefineIconContainer
      className={props.className}
      size={props.size}
      lightoff={props.lightOff ? 1 : 0}
    >
      {props.size === "small" && (
        <RefineIconImage size={props.size} src={LampIconSmall} />
      )}
      {props.size === "medium" && (
        <RefineIconImage size={props.size} src={LampIconMedium} />
      )}
      {props.size === "large" && (
        <RefineIconImage size={props.size} src={LampIconLarge} />
      )}
    </RefineIconContainer>
  );
};
